import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(({ breakpoints: BP }) => ({
  card: {
    display: 'flex',
    margin: '50px 10%',
    borderRadius: 10,
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    backgroundColor: '#fff',
    color: '#283142',
    boxSizing: 'border-box',
    padding: '40px 60px',
    [BP.between('xs', 'md')]: {
      padding: '7% 5%',
      flexDirection: 'column',
      margin: '35px 5%',
    },
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    color: '#283142',
    paddingLeft: '30px',
    '& h3': {
      fontSize: 14,
      fontWeight: 300,
      textAlign: 'justify',
    },
    [BP.between('xs', 'md')]: {
      padding: 0,
    },
  },

  social: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#b7a493',
    '& h5': {
      marginLeft: 20,
      fontSize: 14,
    },
    '& a': {
      transition: 'all 0.2s ease-in-out',
      backgroundColor: '#b7a493',
      color: '#f3f3f3',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 35,
      height: 35,
      borderRadius: '50%',
      marginRight: 15,
      border: '1px solid #b7a493',
      '&:hover': {
        color: '#b7a493',
        backgroundColor: '#f3f3f3',
        transform: 'scale(1.2)',
      },
    },
    [BP.between('xs', 'md')]: {
      flexDirection: 'column',
      '& h5': {
        margin: 0,
      },

      '& a': {
        marginRight: 0,
      },
    },
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    margin: '20px 0',
  },
  video: {
    flex: 1,
    borderRadius: 50,
    border: 'none',
    outline: 'none',
    '& svg': {
      fontSize: 125,
      color: '#ffdf80',
    },
    [BP.between('xs', 'md')]: {
      minHeight: '23vh',
      borderRadius: 10,
      '& svg': {
        fontSize: 55,
      },
    },
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 20,
    '& span': {
      width: 22,
      height: 22,
      backgroundColor: '#218683',
      borderRadius: 15,
      marginLeft: 10,
    },
    '& h1': {
      fontSize: 30,
      fontWeight: 'bold',
      margin: '0 20px 0',
    },
    [BP.between('xs', 'md')]: {
      marginBottom: 10,
      '& h1': {
        margin: '0 15px 0 0',
      },
      '& span': {
        width: 18,
        height: 18,
        marginLeft: 5,
      },
    },
  },
  butCont: {
    margin: '20px 0',
    display: 'flex',
    justifyContent: 'flex-end',
    '& button': {
      borderRadius: 10,
      width: 125,
    },
    [BP.between('xs', 'md')]: {
      justifyContent: 'space-between',
      '& button': {
        padding: '5px 10px',
        width: 'auto',
      },
    },
  },
  but: {
    backgroundColor: '#53b9b6',
    border: '2px solid #53b9b6',
    color: '#fff',
    marginRight: 20,
    '&:hover': {
      backgroundColor: '#fff',
      color: '#53b9b6',
    },
  },
  but2: {
    backgroundColor: '#ffdf80',
    border: '2px solid #ffdf80',
    color: '#47494d',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#ffdf80',
    },
  },
}));
